import { Measurement, Sample, Label } from './measurement';
import { Parser } from 'json2csv';

export default class CSVPublisher {

    private measurement: Measurement;

    public constructor(measurement: Measurement) {
        this.measurement = measurement;

    }

    public toCSV() {
        const options = { flatten: true, flattenSeparator: '-', quote: '' };
        const json2csvParser = new Parser( options );
        const csv = json2csvParser.parse(this.prepareData(this.measurement));
        return csv;
    }

    private prepareData(measurement: Measurement) {
        const data: any[] = this.mergeSamplesAndLabels(measurement);
        data.sort( (a, b) => {
            return a.timestamp.getTime() - b.timestamp.getTime();
        });
        data.map( (row) =>  {
            row.exercise = measurement.exercise;
        });
        return data;
    }

    private mergeSamplesAndLabels(measurement: Measurement): Array<Sample|Label> {
        let data: Array<Sample|Label> = [];
        data = data.concat(measurement.samples);
        data = data.concat(measurement.labels);
        return data ;
    }
}
